module.exports = {
  production: true,
  api: "https://api.pluxapp.com/v1/backoffice",
  amplify: {
    region: "eu-west-1",
    userPoolId: "eu-west-1_NORu9bB1R",
    userPoolWebClientId: "1tj83mnjett90cjs5ehk8j8scd",
  },
};
  